import styled from 'styled-components';
import { getTextColor, themeGet } from '@magalu/stereo-ui-styles';
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  text-align: center;
`;
export const Title = styled.h2`
  font-size: ${props => themeGet('fontSizes.4')(props)}px;
  line-height: ${props => themeGet('lineHeights.fontSize')(props)};
  font-weight: ${props => themeGet('fontWeights.medium')(props)};
  color: ${props => props.color};
  margin: 10px;
`;
export const Description = styled.p`
  font-size: ${props => themeGet('fontSizes.2')(props)}px;
  line-height: ${props => themeGet('lineHeights.display')(props)};
  color: ${props => getTextColor('base')(props)};
  margin: 15px 0;
  width: 80%;
`;